<template>
<div class="on-job-edit-page">
  <div class="page-body container">
    <div class="header-box">
      <div class="left-box">
        <img @click="$router.back()" src="../../assets/imgs/on-job/icon-back.png" class="left-img" alt="">
        <div class="title">在职证明 - 填写信息</div>
        <div class="tips">
          <img src="../../assets/imgs/on-job/tips-gray.png" class="icon" alt="">
          <div class="text">请完善客户信息，若当前部分信息缺失，可先提交后在列表页编辑补充</div>
        </div>
      </div>
      <div class="right-box">
        <share-on-job v-if="currInfo" :job-info="currInfo"></share-on-job>
        <el-button class="s-btn btn-blue btn-lg" :loading="loading" @click="submit">{{infoList.length > 1 ? '全部提交' : '提交'}}</el-button>
      </div>
    </div>
    <div class="form-box">
      <edit-on-job-tab
        v-if="infoList.length"
        :info-list="infoList"
        :active-index="tabIndex"
        :check-result="checkResult"
        @changeIndex="changeTabIndex"
      ></edit-on-job-tab>
      <div class="form-content" v-if="currInfo">
        <el-form :model="currInfo" ref="dataForm" :inline="true" label-position="top">
          <div class="form-section">
            <div class="section-header">
              <div class="header-title">护照信息</div>
            </div>
            <div class="section-content">
              <edit-form-passport
                :on-job-info="currInfo"
                :check-config="checkConfig"
              ></edit-form-passport>
            </div>
          </div>

          <div class="form-section">
            <div class="section-header">
              <div class="header-title">个人信息</div>
            </div>
            <div class="section-content">
              <edit-form-personal
                :on-job-info="currInfo"
                :check-config="checkConfig"
              ></edit-form-personal>
            </div>
          </div>

          <div class="form-section">
            <div class="section-header">
              <div class="header-title">公司信息</div>
            </div>
            <div class="section-content">
              <edit-form-company
                :on-job-info="currInfo"
                :check-config="checkConfig"
              ></edit-form-company>
            </div>
          </div>

        </el-form>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import moment from 'moment';
import sensorsdata from 'sa-sdk-javascript';
import User from '../../libs/user.js';
import EditOnJobTab from './components/edit-on-job-tab';
import Http from '../../libs/http';
import validates from '../../libs/validates';
import EditFormPassport from './components/edit-form-passport.vue';
import EditFormPersonal from './components/edit-form-personal.vue';
import EditFormCompany from './components/edit-form-company';
import utils from '../../libs/utils';
import ShareOnJob from './components/share-on-job';

const notCn = /^[^\u4e00-\u9fa5]+$/;

export default {
  components: {
    EditOnJobTab,
    EditFormPassport,
    EditFormPersonal,
    EditFormCompany,
    ShareOnJob,
  },
  data() {
    return {
      tabIndex: 0, // 当前选中的index
      idList: [], // 当前编辑的id list
      infoList: [], // 当前编辑的在职信息list
      checkConfig: { // 字段校验的配置
        passport_content: {
          passport_num: validates.inputRegexpCollection.passport,
          surname_cn: validates.inputRegexpCollection.cn,
          name_cn: validates.inputRegexpCollection.cn,
          surname_pinyin: validates.inputRegexpCollection.enLetter,
          name_pinyin: validates.inputRegexpCollection.enLetter,
          birthday: validates.inputRegexpCollection.any,
          sex: validates.inputRegexpCollection.number,
        },
        personal_content: {
          company_name: validates.inputRegexpCollection.any,
          company_name_en: notCn,
          job: validates.inputRegexpCollection.any,
          job_en: notCn,
          hiredate: validates.inputRegexpCollection.any,
          monthly_income: validates.inputRegexpCollection.amount,
          purpose: validates.inputRegexpCollection.any,
          purpose_en: notCn,
          country_id: validates.inputRegexpCollection.number,
          country: validates.inputRegexpCollection.any,
          country_en: validates.inputRegexpCollection.any,
          arrival_date: validates.inputRegexpCollection.any,
          return_date: validates.inputRegexpCollection.any,
        },
        company_content: {
          province_code: validates.inputRegexpCollection.number,
          city_code: validates.inputRegexpCollection.number,
          company_tel: /^[\d-]+$/,
          detail_addr: validates.inputRegexpCollection.any,
          detail_addr_en: notCn,
          leader_name: notCn,
          leader_job: validates.inputRegexpCollection.any,
          leader_job_en: notCn,
          closing_date: validates.inputRegexpCollection.any,
        },
      },
      checkResult: [], // 校验的结果, 结果， -1：有错误， 0：无错误，未填写完成，1：无错误已填写完成
      loading: false,
      allowBack: false,
    };
  },
  computed: {
    currInfo() {
      return this.infoList[this.tabIndex];
    },
  },
  beforeRouteLeave(from, to, next) {
    if (this.allowBack) return next();
    utils.msgbox.confirm('客户信息未提交保存，确认离开吗？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
    }).then(() => {
      next();
    }).catch((e) => {
      if (e) console.log(e);
      next(false);
    });
  },
  created() {
    try {
      this.idList = JSON.parse(decodeURIComponent(this.$route.query.id_list));
    } catch (e) {
      this.idList = [];
    }
    if (!this.idList.length) {
      this.allowBack = true;
      this.$router.back();
      return;
    }

    this.getOnJobInfoList();

  },
  methods: {
    changeTabIndex(index) {
      this.tabIndex = index;
      // 切换的时候校验一下
      this.$nextTick(() => {
        this.$refs.dataForm.validate();
        // 切换后，需要把当前的感叹号去除
        if (this.checkResult[index] === -1) this.$set(this.checkResult, index, 0);
      });
    },
    // 获取列表
    getOnJobInfoList() {
      Http.post('/archives_onjob_query', {
        onjob_id_list: this.idList,
      }).then((res) => {
        // 初始化一些数据
        res.data.forEach((item) => {
          if (item.personal_content.monthly_income) {
            item.personal_content.monthly_income = +item.personal_content.monthly_income / 100;
          }
          item.company_content.closing_date = moment().format('YYYY-MM-DD');
        });
        this.infoList = res.data;
      });
    },
    // 检查在职信息
    checkInfoList() {
      this.infoList.forEach((infoItem, index) => {
        // 默认结果未0：无错误，未填写完整
        // 循环校验的配置，目前是两层，所以循环两次
        let existError = false; // 是否存在错误
        let existNotFilled = false; // 是否存在未填写
        Object.keys(this.checkConfig).forEach((firstKey) => {
          Object.keys(this.checkConfig[firstKey]).forEach((secondKey) => {
          // 字段的校验规则
            const rule = this.checkConfig[firstKey][secondKey];
            // 对应字段的value
            const fieldValue = infoItem[firstKey][secondKey];
            if (fieldValue || fieldValue === 0) {
              // 有值
              if (rule.test(fieldValue)) {
              // 校验通过
                return true;
              }
              // 走到这说明报错了
              existError = true;
            } else {
              existNotFilled = true;
            }
          });
        });
        //  -1：有错误， 0：无错误，未填写完成，1：无错误已填写完成
        if (existError) {
          this.$set(this.checkResult, index, -1);
        } else if (existNotFilled) {
          this.$set(this.checkResult, index, 0);
        } else {
          this.$set(this.checkResult, index, 1);
        }
        // 同时更新一下在职证明信息的状态
        infoItem.status = this.checkResult[index];
      });
    },

    getSubmitParams() {
      const onjob_list = utils.deepCopy(this.infoList);
      onjob_list.forEach((item) => {
        if (item.personal_content.monthly_income) {
          item.personal_content.monthly_income = utils.mul(+item.personal_content.monthly_income, 100);
        }
      });
      return onjob_list;
    },

    submit() {
      if (!this.infoList.length) return;
      this.checkInfoList();
      if (this.checkResult.every(result => result !== -1)) {
        // 可提交
        if (this.loading) return;
        this.loading = true;

        Http.post('/archives_onjob_update', {
          onjob_list: this.getSubmitParams(),
        }).then(() => {
          sensorsdata.track('On_the_job_all_submissions', {
            peer_name: User.peer.peer_name,
            visa_peer_id: User.peer.visa_peer_id,
          });
          this.$message.success('保存成功，请到列表页进行预览打印');
          this.loading = false;
          this.allowBack = true;
          this.$router.back();
        }).catch(() => {
          this.loading = false;
        });
      } else {
        // 存在错误
        this.$message.error('请检查修改红框处错误信息后提交');
        // 触发一下切换tab，主要为了重新触发校验
        this.changeTabIndex(this.tabIndex);
      }
    },

  },
};
</script>

<style lang="less" scoped>
.on-job-edit-page{
  padding: 20px 0;
  min-height: calc(~"100vh - 395px");
  /deep/ .el-input{
    width: 100%;
    .el-input__inner{
      height: 40px;
      border-radius: 2px;
    }
  }
  /deep/ .el-select{
    width: 100%;
  }
  .page-body{
    width: 1120px;
    background: #fff;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.06);
    border-radius: 2px;
    .header-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 72px;
      padding: 0 24px;
      border-bottom: 1px solid #F0F0F0;
      .left-box{
        display: flex;
        align-items: center;
        .left-img{
          width: 24px;
          height: 24px;
          cursor: pointer;
        }
        .title{
          margin-left: 8px;
          color: #2F333D;
          font-size: 18px;
          font-weight: 600;
        }
        .tips{
          margin-left: 8px;
          display: flex;
          align-items: center;
          .icon{
            width: 14px;
            height: 14px;
            margin-right: 3px;
          }
          .text{
            color: #5F666E;
            font-size: 14px;
          }
        }
      }
      .right-box{
        display: flex;
        align-items: center;
        gap: 16px;
        .s-btn{
          width: 128px;
        }
      }
    }
    .form-box{
      display: flex;
      .form-content{
        flex-grow: 1;
        overflow: hidden;
        padding: 24px;
        .form-section{
          width: 100%;
          margin-top: 18px;
          &:first-child{
            margin-top: 0;
          }
          .section-header{
            height: 44px;
            background: linear-gradient(270deg, #FFFFFF 0%, #F5FAFF 100%);
            padding: 0 12px;
            display: flex;
            align-items: center;
            .header-title{
              color: #2F333D;
              font-size: 16px;
            }
          }
          .section-content{
            margin-top: 20px;
            /deep/ .el-form-item{
              width: 100%;
              .form-item-label{
                line-height: 1;
                margin-bottom: 5px;
              }
            }

            /deep/ .translate-box{
              width: 100%;
              height: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              margin-top: 23px;
              .translate-img{
                width: 32px;
                height: 32px;
                background: url(../../assets/imgs/on-job/translate-img.png) no-repeat center / 100% 100%;
              }
            }

          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/on-job/EditOnJob.vue